import 'normalize.css';
import angular from 'angular';
import uiRouter from 'angular-ui-router';

import videogular from 'videogular';
import videogularControls from 'videogular-controls';
import videogularPoster from 'videogular-poster';
import videogularBuffer from 'videogular-buffering';

import Common from './common/common';
import Components from './components/components';

import './remote/remote';
import './api/api';
import './navigation/navigation';
import './storage/storage';
import './mock/mock';

import Services from './services/services';
import AppComponent from './app.component';

angular.module('app', [
    uiRouter,
    Common.name,
    Components.name,
    Services.name,
    'remote',
    'navigation',
    'mockservices',
    'labox.sse.api',
    'storage',
    "com.2fdevs.videogular",
    "com.2fdevs.videogular.plugins.controls",
    "com.2fdevs.videogular.plugins.poster",
    "com.2fdevs.videogular.plugins.buffering"
  ])
  .config(($locationProvider) => {
    "ngInject";
    // @see: https://github.com/angular-ui/ui-router/wiki/Frequently-Asked-Questions
    // #how-to-configure-your-server-to-work-with-html5mode
    $locationProvider.html5Mode(true).hashPrefix('!');
  })
  .run(['$rootScope','$window','$state', ($rootScope, $window, $state) => {
    $rootScope.$on('$stateChangeSuccess', (event, to, toParams, from, fromParams) => {
      // save the previous state in a rootScope variable so that it's accessible from everywhere
      $rootScope.previousState = from;
    });
  }])

  .component('app', AppComponent);



// WEBPACK FOOTER //
// ./client/app/app.js